export const routeConfig = {
  meta: {
    title: '评分查询',
  },
};
